<script setup lang="ts">
import { ref } from 'vue'

import HomeMap from '@/components/GIS/HomeMap.vue'
import BaseLayerSelector from './Map/ToolsPannel/BaseLayerSelector.vue'

import BaseWidget from './Map/ToolsPannel/BaseWidget.vue'
import BasePannel from './Map/ToolsPannel/BasePannel.vue'
import SearchInput from './Map/ToolsPannel/SearchInput.vue'
import BridgeDetail from './Map/ToolsPannel/RightChildPannel/bridgeDetail.vue'
import MarkDetail from './Map/ToolsPannel/RightChildPannel/markDetail.vue'
import RescuDetail from './Map/ToolsPannel/RightChildPannel/rescuDetail.vue'

// 信息弹窗
import CameraDialog from './Dialog/CameraDialog.vue'
import DynamicShipDialog from './Dialog/DynamicShipDialog.vue'

const showPannelKey = ref('') // 显示的组件key
const searchValue = ref('') // 搜索框
const bridgeId = ref<number>()
const markInfoId = ref<number>()
const resumId=ref<number>()

const basePannelRef = ref()
const searchHandle = () => {
  basePannelRef.value?.getList()
}
</script>

<template>
  <div>
    <HomeMap />

    <!-- 地图图层切换 -->
    <BaseLayerSelector />

    <!-- 动态船舶弹窗 -->
    <DynamicShipDialog />

    <!-- 视频弹窗 -->
    <CameraDialog />
    <!-- <BaseLeftPannel v-if="userStore.isLogin" v-model:bandKey="showPannelKey" /> -->
    <BaseWidget @searchHandle="searchHandle" v-model:bandKey="showPannelKey" />
    <!-- 桥梁详情信息弹窗 -->
    <BridgeDetail v-model:bandKey="showPannelKey" v-model:bridgeId="bridgeId" />
    <!-- 航标详情弹窗 -->
    <MarkDetail v-model:bandKey="showPannelKey" v-model:markInfoId="markInfoId" />
    <!-- 搜救站详情 -->
    <RescuDetail v-model:bandKey="showPannelKey" v-model:resumId="resumId" />

    <!-- 码头详情 -->
    <SearchInput
      @searchHandle="searchHandle"
      v-model:bandKey="showPannelKey"
      v-model:searchValue="searchValue"
    />
    <BasePannel
      ref="basePannelRef"
      v-model:bandKey="showPannelKey"
      v-model:searchValue="searchValue"
      v-model:bridgeId="bridgeId"
      v-model:markInfoId="markInfoId"
      v-modal:resumId="resumId"
    />
  </div>
</template>
